import React from 'react';
import { Button } from '@crisellevaldez/speculo-ui';
import { Eye, EyeOff, ArrowLeft } from 'lucide-react';

interface BuilderToolbarProps {
  showPreview: boolean;
  onTogglePreview: () => void;
  onBack?: () => void;
}

export const BuilderToolbar: React.FC<BuilderToolbarProps> = ({
  showPreview,
  onTogglePreview,
  onBack,
}) => {
  return (
    <div className="sticky top-0 z-50 bg-white border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-6 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            {onBack && (
              <Button
                variant="outline"
                size="sm"
                onClick={onBack}
                className="inline-flex items-center gap-2"
              >
                <ArrowLeft className="w-4 h-4" />
                Back to Form
              </Button>
            )}
            <h2 className="text-lg font-semibold text-gray-900">Visual Page Builder</h2>
          </div>

          <div className="flex items-center gap-3">
            <Button
              variant="secondary"
              size="sm"
              onClick={onTogglePreview}
              className="inline-flex items-center gap-2"
            >
              {showPreview ? (
                <>
                  <EyeOff className="w-4 h-4" />
                  Edit Mode
                </>
              ) : (
                <>
                  <Eye className="w-4 h-4" />
                  Preview Mode
                </>
              )}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
